import * as React from 'react';
import clsx from 'clsx';
import styles from './ResultCount.module.css';

export interface ResultCountProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Index of the first row on this page (the API's `meta.from`) */
  from: number;
  /** Index of the last row on this page (the API's `meta.to`) */
  to: number;
  /** Total matching records across all pages (the API's `meta.total`) */
  total: number;
  /** Singular noun for the records, e.g. "contact" */
  noun: string;
  /** Plural form, when it isn't simply `noun + "s"` */
  nounPlural?: string;
}

/**
 * Summarises which slice of a filtered list is on screen, e.g.
 * "Showing 1-25 of 132 contacts". Renders nothing when there are no results —
 * the empty state says that better.
 */
export function ResultCount({
  from,
  to,
  total,
  noun,
  nounPlural,
  className,
  ...props
}: ResultCountProps) {
  if (!total) return null;

  const label = total === 1 ? noun : (nounPlural ?? `${noun}s`);

  return (
    <div className={clsx(styles.resultCount, className)} {...props}>
      Showing {from}-{to} of {total} {label}
    </div>
  );
}
